<div
  class="z-date"
  [class.with-label]="!!label"
  [class.show-clear-button]="showClearButton"
  [class.read-only]="readonly || disabled"
  [formGroup]="formGroup.form"
>
  <z-label *ngIf="!!label && !hideLabel" [id]="elementId" [text]="label"></z-label>

  <p-calendar
    #calendar
    styleClass="z-date-input"
    panelStyleClass="z-date-panel"
    [disabledDates]="disabledDates"
    [disabledDays]="disabledDays"
    [formControlName]="fieldName"
    [inputId]="elementId"
    [maxDate]="maxDate"
    [maxDateCount]="maxDateCount"
    [minDate]="minDate"
    [multipleSeparator]="multipleSeparator"
    [placeholder]="placeholder"
    [rangeSeparator]="rangeSeparator"
    [readonlyInput]="readonly || !manualInput"
    [selectionMode]="selectionMode"
    [showButtonBar]="showButtonBar"
    [showIcon]="!readonly"
    [showOnFocus]="!readonly && showOnFocus"
    [showSeconds]="showSeconds"
    [showTime]="showTime"
    [timeOnly]="timeOnly"
    [firstDayOfWeek]="firstDayOfWeek"
    [dateFormat]="dateFormat"
    [hourFormat]="hourFormat"
    [appendTo]="appendTo"
    (onSelect)="onSelect($event)"
    (onBlur)="onBlur($event)"
    (onFocus)="onFocus($event)"
    (onClose)="onClose($event)"
    (onShow)="onShow($event)"
    (onClickOutside)="onClickOutside($event)"
    (onInput)="onInput($event)"
    (onTodayClick)="onTodayClick($event)"
    (onClearClick)="onClearClick($event)"
    (onMonthChange)="onMonthChange($event)"
    (onYearChange)="onYearChange($event)"
  ></p-calendar>

  <z-clear-button *ngIf="!readonly && !disabled" (click)="onClearClick($event)"></z-clear-button>

  <z-hint [text]="hint" *ngIf="!!hint"></z-hint>

  <z-validation *ngIf="displayValidationErrors" [control]="this.formGroup.form.controls[this.fieldName]"></z-validation>

  <z-match-type
    *ngIf="matchTypes"
    type="date"
    [controlWithoutLabel]="!label"
    defaultMatchType="equals"
    [enableBetweenMatchType]="selectionMode !== 'single'"
    (change)="onMatchTypeChange($event)"
  ></z-match-type>
</div>
